import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMessageCircle } = FiIcons;

const WhatsAppButton = () => {
  return (
    <motion.a
      href="https://wa.me/919940890569?text=Hi,%20I%20need%20help%20with%20My%20Webinar%20Financial%20Year%20End%20offer"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-40 w-14 h-14 bg-green-600 hover:bg-green-700 rounded-full flex items-center justify-center text-white shadow-lg hover:shadow-xl transition-all"
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      transition={{ delay: 2, type: "spring", damping: 15 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
    >
      <SafeIcon icon={FiMessageCircle} className="text-xl" />
      <div className="absolute inset-0 rounded-full bg-green-600 animate-ping opacity-20"></div>
    </motion.a>
  );
};

export default WhatsAppButton;